module.exports = __webpack_public_path__ + "img/login-illustration.7e7e2647.svg";